export default __webpack_public_path__ + "static/mode13h-8549097998892f3314d35b2b7da2613c.jpg";